import { createStore, applyMiddleware } from "redux";
import { enableBatching } from 'redux-batched-actions';
import thunk from 'redux-thunk';
import rootReducer from "./reducers/index";
import { loadFromLocalStorage, saveToLocalStorage } from './local-storage'

export default createStore(enableBatching(rootReducer), loadFromLocalStorage(), applyMiddleware(thunk));